import { useEffect, useState } from "react";
import { update as setBreadCrumbs } from "../../redux-store/breadCrumbsSlice";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import API from "../../api";
import { CircularProgress } from "@mui/material";
import { FullPageFormWrapper } from "../../components/Forms/shared";
import AdminDeviceSettingsForm from "../../components/Forms/adminDeviceSettingsForm";
import colors from "../../theme/colors";
import ModalComponent from "../../components/Modal";
import ConfirmForm from "../../components/Forms/confirmForm";

import {
  remove as removeNotification,
  add as addNotification,
} from "../../redux-store/notificationsSlice";

const EditDeviceSettingComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { deviceId } = useParams();
  const [device, setDevice] = useState({});

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [savingError, setSavingError] = useState(false);

  useEffect(() => {
    dataLayer.GetDevice();
    dispatch(
      setBreadCrumbs([
        {
          title: "Admin Devices",
          link: "/admin/devices",
        },
        {
          title: `...`,
          link: `/admin/devices/`,
        },
      ]),
    );
  }, []);

  useEffect(() => {
    if (!device?.name) return;
    dispatch(
      setBreadCrumbs([
        {
          title: "Admin Devices",
          link: "/admin/devices",
        },
        {
          title: `${device.name}`,
          link: `/admin/devices/${deviceId}`,
        },
        {
          title: `Device Settings`,
          link: `/admin/devices/${deviceId}/settings/edit`,
        },
      ]),
    );
  }, [device]);

  const dataLayer = {
    GetDevice: async () => {
      const device = await API.Device.DeviceGet({
        deviceId,
        pullMetrics: true,
      });

      setDevice(device);

      // setLoadingDevice(false);
    },
  };

  const handlers = {
    saveDeviceSettings: async (data) => {
      setSavingError("");
      setSaving(true);
      try {
        await API.Device.DeviceSettingsSave({
          body: { ...data },
        });

        //Create Success Notification
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "success",
            title: "Success",
            message: "Devices Settings Saved Successfully",
          }),
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
        navigate(`/admin/devices/${deviceId}`);
      } catch (err) {
        let errorMessage = err;
        switch (err) {
          case "particle-device-id-in-use-already":
            errorMessage =
              "Particle Device Id is already linked to a Device in the System";
            break;
          default:
            break;
        }

        setSavingError(errorMessage);

        console.log(err);
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "error",
            title: "Error Saving Device Settings",
            message: errorMessage,
          }),
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
      }
      setSaving(false);
    },
    cancel: () => {
      navigate(`/admin/devices/${deviceId}`);
    },
  };

  return (
    <>
      <FullPageFormWrapper>
        <h2>
          Device Settings
          <span style={{ color: colors.gray }}>
            {" "}
            / Devices / {device?.name}
          </span>
        </h2>
        {device.id ? (
          <AdminDeviceSettingsForm
            handleSave={handlers.saveDeviceSettings}
            handleCancel={handlers.cancel}
            saving={saving}
            error={savingError}
            device={device}
          />
        ) : (
          <CircularProgress />
        )}
        {/* {locationsLoaded && locations.length === 0 && (
          <NoChartDataPlaceholder
            header={"THERE ARE NO LOCATIONS IN THIS ORGANIZATION"}
            body={"To add a tank, you must have at least one location created"}
            buttonText={"Add Location"}
            buttonPath={`/${organizationId}/locations`}
          />
        )} */}
      </FullPageFormWrapper>
      <ModalComponent
        open={showConfirmModal}
        handleClose={handlers.confirmModalCancel}
        headerText={"Cancel Add New Devices"}
      >
        <ConfirmForm
          handleSave={handlers.confirmModalSubmit}
          handleCancel={handlers.confirmModalCancel}
          loading={false}
        >
          <div>
            <b>Are you sure you want to Cancel Adding New Devices?</b>
            <p>You will lose all progress.</p>
          </div>
        </ConfirmForm>
      </ModalComponent>
    </>
  );
};

export default EditDeviceSettingComponent;
